/**
 * Uncomment NavbarFrontend untuk mengggunakan Navbar Sebelumnya
 * Navbar yg di pakai sekarang bawaan dari react bootstrap
 * Untuk halaman detail danhome dipindahkan ke folder pages
 */

//import NavbarFrontend from '../components/Frontend/Navbar/NavbarFrontend'
import NavbarFrontend from "../components/react-bootstrap/NavbarFrontend";
import React from "react";
import { Route, Switch } from "react-router-dom";
import routes from "../routes/routes";
import FooterFrontend from "components/Frontend/Footer/FooterFrontend";

const FrontendLayout = () => {
  return (
    <div>
      <NavbarFrontend />
      <div>
        <section className="new-content">
          <Switch>
            {routes.map((route, idx) => {
              return (
                route.component && (
                  <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    render={(props) => <route.component {...props} />}
                  />
                )
              );
            })}
          </Switch>
        </section>
        <FooterFrontend />
      </div>
    </div>
  );
};

export default FrontendLayout;
